<template>
  <div class="fzmOrderSubscription">

    <div class="orderSubsBody">
        <div class="container">
            <h1>Orders</h1>
            <p>It’s nice to see you here {{user ? user.first_name : ''}}.</p>

            <div class="orderSubsTab">

                 <b-tabs content-class="mt-3" >
                    <b-tab title="Subscription" active>
                        <subscription-tab />
                    </b-tab>

                    <b-tab title="Profile">
                        <profile-tab />
                    </b-tab>

                    <b-tab title="Order History">
                        <order-history />
                    </b-tab>
                </b-tabs>

            </div>
        </div>
    </div>
</div>
</template>

<script>
// components
import subscriptionTab from '@/components/subscriptionTab.vue';
import subscriptionProfile from '@/components/subscriptionProfileTab.vue';
import subscriptionOrderHistory from '@/components/subscriptionOrderHistory.vue';

export default {
    components : {
        'subscription-tab': subscriptionTab,
        'profile-tab'     : subscriptionProfile,
        'order-history'   : subscriptionOrderHistory
    },
    computed : {
        /**
         * User data
         */
        user() {
            return this.$store.state.user
        }
    }
    
}
</script>

<style lang="scss">
.fzmOrderSubscription {

    .orderSubsBody {
        min-height: 100vh;
    }
}
</style>